// src/components/AnnouncementsPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
  import { useAuth } from '../pages/authContext';

import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GavelIcon from '@mui/icons-material/Gavel';
import PhoneIcon from '@mui/icons-material/Phone';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CottageIcon from '@mui/icons-material/Cottage';
import PaidIcon from '@mui/icons-material/Paid';
import ListingItem from "../components/ListingItem.jsx";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NewPatientModal from '../pages/NewPatientModal.jsx.jsx';
import { Button, Modal } from 'react-bootstrap';
import LockIcon from '@mui/icons-material/Lock';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import { MapContainer, Popup, Marker, TileLayer } from "react-leaflet";
import { getAuth } from "firebase/auth";
import Contact from "../components/Contact";
import GaugeComponent from 'react-gauge-component';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import { doSignOut } from '../pages/auth.js';
import PeopleIcon from '@mui/icons-material/People';
import { Chip } from "@mui/material";

import ProfileComponent from '../pages/ProfileComponent.jsx';
import { CreditCard } from '@mui/icons-material';
import StateModal from '../pages/StateModal.jsx';
import TenantModal from '../pages/TenantModal.jsx';
const emojis = ["🚨", "😂", "💪", "👍", "❗️", "🔥", "💯", "😎", "👀", "🍴"];

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#202225'
  },
  messagesContainer: {
    flex: 1,
    overflowY: 'auto',
    padding: '10px'
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    backgroundColor: '#2f3136',
    borderTop: '1px solid #202225'
  },
  input: {
    flex: 1,
    padding: '8px',
    marginLeft: '10px',
    backgroundColor: '#40444b',
    border: 'none',
    borderRadius: '4px',
    color: '#fff'
  },
  sendButton: {
    marginLeft: '10px',
    padding: '8px 12px',
    backgroundColor: '#7289da',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    cursor: 'pointer'
  },
  emojiPicker: {
    display: 'flex',
    overflowX: 'auto',
    padding: '5px',
    backgroundColor: '#2f3136',
    borderTop: '1px solid #202225'
  },
  emojiButton: {
    fontSize: '20px',
    padding: '5px',
    cursor: 'pointer'
  },
  messageItem: {
    display: 'flex',
    marginBottom: '15px',
    cursor: 'context-menu'
  },
  avatar: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    marginRight: '10px'
  },
  messageContent: {
    color: '#dcddde'
  },
  sender: {
    color: '#28a745',
    fontWeight: 'bold',
    marginBottom: '4px'
  },
  text: {
    marginBottom: '4px'
  },
  time: {
    color: '#b9bbbe',
    fontSize: '12px'
  },
  reactions: {
    display: 'flex',
    marginTop: '4px'
  },
  reaction: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#2f3136',
    borderRadius: '12px',
    padding: '2px 6px',
    marginRight: '4px'
  },
  reactionEmoji: {
    marginRight: '4px'
  },
  reactionOverlay: {
    position: 'fixed',
    backgroundColor: '#36393f',
    padding: '10px',
    borderRadius: '8px',
    display: 'flex'
  }
};
  const OpenModalButton = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Housing Authority</button>
        <StateModal open={open} onClose={handleClose} />
      </>
    );
  };


  
  const OpenModalButton2 = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Tenant Lookup</button>
        <TenantModal open={open} onClose={handleClose} />
      </>
    );
  };
function MessageItem({ item, onReact }) {
  const [timeString, setTimeString] = useState('');

  useEffect(() => {
    const date = item.createdAt?.toDate?.() || new Date();
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    setTimeString(
      isToday
        ? date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : date.toLocaleDateString()
    );
  }, [item.createdAt]);

  const handleContextMenu = e => {
    e.preventDefault();
    onReact(item, e.clientX, e.clientY);
  };

  return (
    <div style={styles.messageItem} onContextMenu={handleContextMenu}>
      <img src={item.avatar} alt="" style={styles.avatar} />
      <div style={styles.messageContent}>
        <div style={styles.sender}>{item.sender}</div>
        <div style={styles.text}>{item.text}</div>
        <div style={styles.time}>{timeString}</div>
        {item.reactions && Object.keys(item.reactions).length > 0 && (
          <div style={styles.reactions}>
            {Object.entries(item.reactions).map(([emoji, users]) => (
              <div key={emoji} style={styles.reaction}>
                <span style={styles.reactionEmoji}>{emoji}</span>
                <span>{users.length}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function AnnouncementsPage() {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [announcements, setAnnouncements] = useState([]);
  const [messageText, setMessageText] = useState('');
    const [user, setUser] = useState(null);
  
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [reactionTarget, setReactionTarget] = useState(null);
  const messagesEndRef = useRef(null);
  const { currentUser } = useAuth()

  // Load user profile
  useEffect(() => {
    setTimeout(()=>{

    firebase
      .firestore()
      .collection("users")
      .doc(currentUser.uid)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setUser(snapshot.data());
          console.log("USERID", currentUser.uid)
          console.log("USER", user)

        } else {
          console.log("does not exist");
        }
      });
    }, 1000)
}, []);

  // Subscribe to announcements
  useEffect(() => {
    const unsub = firebase
      .firestore()
      .collection('announcements')
      .orderBy('createdAt', 'asc')
      .onSnapshot(snap => {
        const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setAnnouncements(data);
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
      });
    return () => unsub();
  }, []);

  // Send new announcement
  const sendAnnouncement = async () => {
    if (!messageText.trim()) return;
    await firebase
      .firestore()
      .collection('announcements')
      .add({
        text: messageText,
        sender: loggedInUser?.name || 'You',
        avatar:
          loggedInUser?.ppUrl ||
          'https://cdn-icons-png.flaticon.com/512/8801/8801434.png',
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      });
    setMessageText('');
    setShowEmojiPicker(false);
  };

  // Trigger reaction overlay
  const handleReact = (message, x, y) => {
    setReactionTarget({ message, x, y });
  };

  // Add or remove a reaction
  const addReaction = async emoji => {
    if (!reactionTarget) return;
    const { message } = reactionTarget;
    const msgRef = firebase
      .firestore()
      .collection('announcements')
      .doc(message.id);

    await firebase.firestore().runTransaction(async tx => {
      const doc = await tx.get(msgRef);
      const reactions = doc.data().reactions || {};
      const users = reactions[emoji] || [];
      reactions[emoji] = users.includes(user.uid)
        ? users.filter(uid => uid !== user.uid)
        : [...users, user.uid];
      tx.update(msgRef, { reactions });
    });

    setReactionTarget(null);
  };

 
   return (
  
 <div
   style={{
     backgroundColor: '#202225',
     margin: 0,
     padding: 0,
     height: '100vh',
     width: '100vw',
     
   }}
 >      {/* <OpenModalButton/> */}

<div style={{ display: "flex", height: "100vh" }}>
      <Sidebar style={{ backgroundColor: '#000222 '}}>
      <Menu style={{ backgroundColor: '#000222'}}>
          <MenuItem >
          <div style={{marginLeft:-43, backgroundColor: 'white'}}>
          <img
            src="https://i.ibb.co/s2dBvDt/elevate.png"
            alt="logo"
            className="ml-4 mt-12 -p-4 "
            width={300}
          ></img>
          </div>
          </MenuItem>
          
          <MenuItem style={{ backgroundColor: '#000222', color:'white', marginTop:'50px'}} onClick ={()=> window.location = 'fmrexplorer'} icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
          <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'propertylookup'}icon={<SearchIcon />}>Market Research</MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'dealcalculator'} icon={<CalculateIcon />}>Deal Calculator</MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'dealexplorer'} icon={<AddHomeIcon />}>Deal Explorer</MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'rentcast'} icon={<SpeedIcon />}>Rent Reveal</MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'skiptrace'} icon={<VisibilityIcon />}>Skip Trace</MenuItem>

          <SubMenu label="Education" style={{ backgroundColor: '#000222', color:'white'}} icon={<SchoolIcon />}>
          <MenuItem style={{ backgroundColor: '#000222', color:'white'}}  onClick ={()=> window.open('https://www.skool.com/elevate-wsection-8-8185', "_blank")} icon={<SchoolIcon />}>Skool Community</MenuItem>

            <MenuItem icon={<AccountBalanceRoundedIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://elevatecoachingrei.com/', "_blank")}>
              Coaching
            </MenuItem>
            <MenuItem icon={<PeopleIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/googlemeet?back=1&month=2025-01', "_blank")}>
              1-on-1s
            </MenuItem>
            <MenuItem icon={<BusinessIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/inoffice?back=1&month=2025-01', "_blank")}>
              Day in the Office
            </MenuItem>
            <MenuItem icon={<DirectionsCarFilledIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/ridealong?back=1&month=2025-01', "_blank")}>
              Ride Along
            </MenuItem>

          </SubMenu>
          {/* <MenuItem icon={<GroupIcon />}>Tenant Finder</MenuItem> */}
          <SubMenu label="Tenant Hub" style={{ backgroundColor: '#000222', color:'white'}} icon={<GroupIcon />}>
            <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<HouseIcon />}> <OpenModalButton/> </MenuItem>
            <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<EmojiPeopleIcon />}> <OpenModalButton2/> </MenuItem>
           
          </SubMenu>
          
            <MenuItem icon={<NoteAddIcon />} disabled style={{ backgroundColor: '#000222', color:'white'}}> Title Setup <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color:'#000222', width:80, height:10, fontSize:8,  marginLeft:'-15px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
            
            
           
                        <MenuItem icon={<GavelIcon />} disabled style={{ backgroundColor: '#000222', color:'white'}}> Legal Hub <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color:'#000222', width:80, height:10, fontSize:8,  marginLeft:'-10px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
                        <MenuItem icon={<CreditCard />} disabled style={{ backgroundColor: '#000222', color: 'white' }}> Credit Tradelines <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color: '#000222', width: 80, height: 10, fontSize: 8, marginLeft: '-73px', fontWeight: 600, marginTop: '-23px' }} /></MenuItem>

           
          <SubMenu label="Insurance Hub" style={{ backgroundColor: '#000222', color:'white'}} icon={<GppGoodIcon />}>
            
            <MenuItem icon={<SupportIcon />} onClick ={()=> window.open('https://elevatecoachingrei.steadilypartner.com/', "_blank")}> Landlord Insurance </MenuItem>
            <MenuItem disabled icon={<CottageIcon />}> Home Warrenties <Chip label={'Coming Soon!'} style={{ backgroundColor: '#000222', color:'white', width:80, height:10, fontSize:8,  marginLeft:'-95px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
            
          </SubMenu>
          <SubMenu label="Business Setup" style={{ backgroundColor: '#000222', color:'white'}} icon={<BusinessIcon />}>
            
            <MenuItem icon={<AddIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Form Entity </MenuItem>
            <MenuItem icon={<RequestQuoteIcon />}onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Taxes </MenuItem>
            <MenuItem icon={<CreditScoreIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Build Credit </MenuItem>
            <MenuItem icon={<LockIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Asset Protection </MenuItem>
            <MenuItem icon={<AttachMoneyIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Business Funding </MenuItem>
            
           
          </SubMenu>
          <SubMenu label="Elevate Financial" style={{ backgroundColor: '#000222', color:'white'}} icon={<PaidIcon />}>
            <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} onClick ={()=> window.open('https://lendsimpli.com/elevate/', "_blank")}  icon={<CurrencyExchangeIcon />}   > Loan Portal </MenuItem>
            {/* <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<SpeedIcon />}> Credit Tradelines </MenuItem> */}
            
           
          </SubMenu>
          {/* <SubMenu label="Settings" style={{ backgroundColor: '#000222', color:'white'}} icon={<SettingsSuggestIcon />}>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<AccountCircleRoundedIcon />}> Account </MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<ShieldRoundedIcon />}> <OpenModalButton/> </MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<NotificationsRoundedIcon />}>
              Notifications
            </MenuItem>
          </SubMenu> */}
          <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<LogoutRoundedIcon />} onClick={() => doSignOut({ callbackUrl: '/', redirect:true })}> Logout </MenuItem>
          <div style={{ ...styles.container, backgroundColor: '#000222',  }}>
          <ProfileComponent user={user } />

    </div>
        </Menu>
    </Sidebar>

      
        <>
<div
    style={{
      ...styles.container,
      flex: 1,                  // ← this is key
      display: "flex",          // make it a column flex so inner scroll works
      flexDirection: "column",
    }}
  >      <div style={styles.messagesContainer}>
        {announcements.map(item => (
          <MessageItem key={item.id} item={item} onReact={handleReact} />
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* Reaction picker overlay */}
      {reactionTarget && (
        <div
          style={{
            ...styles.reactionOverlay,
            top: reactionTarget.y - 50,
            left: reactionTarget.x - 20
          }}
        >
          {emojis.map((e, i) => (
            <span
              key={i}
              style={styles.emojiButton}
              onClick={() => addReaction(e)}
            >
              {e}
            </span>
          ))}
        </div>
      )}

      {/* Emoji picker for new messages */}
      {loggedInUser?.role === 'Admin' && showEmojiPicker && (
        <div style={styles.emojiPicker}>
          {emojis.map((e, i) => (
            <span
              key={i}
              style={styles.emojiButton}
              onClick={() => setMessageText(prev => prev + e)}
            >
              {e}
            </span>
          ))}
        </div>
      )}

      {/* Input for new announcements (Admins only) */}
      {loggedInUser?.role === 'Admin' && (
        <div style={styles.inputContainer}>
          <button onClick={() => setShowEmojiPicker(v => !v)}>😊</button>
          <input
            type="text"
            value={messageText}
            onChange={e => setMessageText(e.target.value)}
            placeholder="Send announcement..."
            style={styles.input}
          />
          <button onClick={sendAnnouncement} style={styles.sendButton}>
            Send
          </button>
        </div>
      )}
    </div>
         
          
        </>
     
    </div>
    </div>
  );
}